(() => {
  const readImageSrc = (value) => {
    if (!value) return '';
    if (typeof value === 'string') return value;
    return (
      value.url ||
      value.src ||
      value.originalSrc ||
      value.original_src ||
      value.preview_image?.src ||
      value.previewImage?.url ||
      ''
    );
  };

  const patchRewards = () => {
    const Rewards = customElements.get('elonail-rewards');
    if (!Rewards || Rewards.prototype.__elonailRuntimeFixApplied) return;

    const proto = Rewards.prototype;
    proto.__elonailRuntimeFixApplied = true;
    const originalNormalizeProduct = proto.normalizeProduct;

    proto.normalizeProduct = function (product = {}) {
      const normalized = originalNormalizeProduct
        ? originalNormalizeProduct.call(this, product)
        : {
            id: Number(product.id || 0),
            title: product.title || '',
            handle: product.handle || '',
            url: product.url || (product.handle ? `/products/${product.handle}` : '#'),
            available: product.available !== false,
            featuredImage: '',
            price: 0,
            variants: [],
          };

      if (!normalized.featuredImage) {
        const variantWithImage = Array.isArray(product.variants)
          ? product.variants.find((variant) =>
              readImageSrc(variant?.featured_image || variant?.featuredImage || variant?.image)
            )
          : null;

        const candidates = [
          product.featuredImage,
          product.featured_image,
          product.image,
          product.images?.[0],
          product.media?.[0]?.preview_image,
          product.media?.[0],
          variantWithImage?.featured_image,
          variantWithImage?.featuredImage,
          variantWithImage?.image,
        ];

        for (const candidate of candidates) {
          const src = readImageSrc(candidate);
          if (src) {
            normalized.featuredImage = src;
            break;
          }
        }
      }

      return normalized;
    };
  };

  const patchProductRewards = () => {
    const ProductRewards = customElements.get('elonail-product-rewards');
    if (!ProductRewards || ProductRewards.prototype.__elonailPortalApplied) return;

    const proto = ProductRewards.prototype;
    proto.__elonailPortalApplied = true;
    const originalOpenGift = proto.openGift;
    const originalCloseGift = proto.closeGift;

    /* Product-page tiers are informational only. Cart quantity state belongs in the cart rewards UI. */
    proto.applyStatus = function () {
      this.querySelectorAll?.('[data-reward-tier-id]').forEach((row) => {
        row.classList.remove('is-active', 'is-next');
      });
    };

    document.querySelectorAll('elonail-product-rewards [data-reward-tier-id]').forEach((row) => {
      row.classList.remove('is-active', 'is-next');
    });

    proto.openGift = async function (gift, tier, trigger) {
      if (!this.modal) return;

      if (!this._giftModalAnchor) {
        this._giftModalAnchor = document.createComment('elonail-gift-info-anchor');
        this.modal.parentNode?.insertBefore(this._giftModalAnchor, this.modal);
      }

      this.modal.__elonailProductRewardsOwner = this;
      if (this.modal.parentNode !== document.body) document.body.appendChild(this.modal);
      return originalOpenGift.call(this, gift, tier, trigger);
    };

    proto.closeGift = function () {
      if (!this.modal) return;
      const result = originalCloseGift.call(this);

      if (this._giftModalAnchor?.parentNode && this.modal.parentNode !== this._giftModalAnchor.parentNode) {
        this._giftModalAnchor.parentNode.insertBefore(this.modal, this._giftModalAnchor.nextSibling);
      }
      this.modal.__elonailProductRewardsOwner = null;
      return result;
    };
  };

  const patchWhenReady = (name, patch) => {
    if (customElements.get(name)) patch();
    else customElements.whenDefined(name).then(patch).catch(() => {});
  };

  patchWhenReady('elonail-rewards', patchRewards);
  patchWhenReady('elonail-product-rewards', patchProductRewards);

  document.addEventListener(
    'click',
    (event) => {
      const modal = event.target.closest?.('[data-gift-info-modal]');
      const owner = modal?.__elonailProductRewardsOwner;
      if (!modal || !owner) return;

      const closeButton = event.target.closest('[data-gift-info-close]');
      if (closeButton) {
        event.preventDefault();
        event.stopPropagation();
        owner.closeGift();
        return;
      }

      const galleryButton = event.target.closest('[data-gift-image-src]');
      if (galleryButton) {
        event.preventDefault();
        event.stopPropagation();
        owner.setMainImage(galleryButton.dataset.giftImageSrc || '', galleryButton);
        return;
      }

      const switchButton = event.target.closest('[data-gift-info-switch]');
      if (switchButton) {
        event.preventDefault();
        event.stopPropagation();
        const tier = owner.findTier(switchButton.dataset.giftTierId);
        const gift = tier?.gifts?.[Number(switchButton.dataset.giftIndex || 0)];
        if (gift) owner.loadGift(gift, tier);
      }
    },
    true
  );
})();
